import ActionType from './action-type'
import {type Action} from './actions'
import {type LoggingOutAction} from '../session-data/actions'
import SessionActionType from '../session-data/action-type'
import {DEFAULT_WAS_VALUE_STATE, type WasValueReduxState} from './state'
import {produce} from 'immer'
import {isEqual} from 'lodash'

export const wasValueReducer = produce(
    (draft: WasValueReduxState = DEFAULT_WAS_VALUE_STATE, action: Action | LoggingOutAction) => {
        switch (action.type) {
            case ActionType.REQUEST_WAS:
                draft.isFetching = true
                break
            case ActionType.RECEIVE_WAS:
                draft.isFetching = false
                if (!isEqual(draft.was, action.payload)) {
                    draft.was = action.payload
                }
                break
            case ActionType.WAS_REQUEST_FAILED:
                draft.isFetching = false
                break
            case SessionActionType.LOGGING_OUT:
                draft = DEFAULT_WAS_VALUE_STATE
                break
            /* istanbul ignore next */
            default:
                break
        }
        return draft
    },
)
